import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useEffect } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ActOperator } from 'shell/models/act-list';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { ItemVM } from 'shell/view-models/item';

interface OperatorListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  codiceStatoEvento?: string;
  tipoEvento?: string;
  label?: string;
  currentCodeOperator?: string;
  setIsInitialOperator?: (res?: boolean) => void;
}

const OperatorListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Operatori',
  currentCodeOperator,
  setIsInitialOperator = noop,
}: OperatorListProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponse<Array<ActOperator>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/operatore-usc/list`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response: AxiosResponse<HttpResponse<Array<ActOperator>>>) => {
        const { data } = response;
        return data?.payload?.map((item) => ({
          id: item.key?.codiceOperatore?.trim() || '',
          value: `${item.descrizioneCognome || ''} ${item.descrizioneNome || ''}`,
        }));
      },
    }
  );

  useEffect(() => {
    if (currentCodeOperator && list.data) {
      const res = ((list.data || []) as Array<ItemVM>).find((el) => el.id === currentCodeOperator);
      setIsInitialOperator(Boolean(res));
    }
  }, [currentCodeOperator, list.data]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="operator-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="operator-list-label"
        id="operator-list"
        name="operator-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list.data as Array<ItemVM>)?.map((operator: ItemVM) => (
          <MenuItem key={operator.id} value={operator.id}>
            {operator.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};
OperatorListComponent.displayName = 'Operator List component';

const OperatorList = memo(OperatorListComponent);

export default OperatorList as typeof OperatorListComponent;
